import React from "react";
import ReportTypeScreen from "../../../Components/Reports/ReportTypeScreen";

function ReportedVideos() {
  return <ReportTypeScreen reportType="video" />;
}

export default ReportedVideos;
